import React from "react";
import mailIcon from "../assets/images/svgs/other/mail.svg";
import webIcon from "../assets/images/svgs/other/web.svg";
import { FaArrowLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import DecorativeSquares from "../components/ui/DecorativeSquares";

const Terms = () => {
  const navigate = useNavigate();
  return (
    <>
      <section className="flex justify-center py-10 px-4">
        <DecorativeSquares />

        <div className="container flex flex-col items-center">
          {/* Header */}
          <div className="relative flex items-center w-full max-w-4xl h-10 mb-6">
            <button
              onClick={() => navigate(-1)}
              className="absolute left-0 flex items-center"
            >
              <FaArrowLeft className="text-lg" />
            </button>

            <h1 className="mx-auto text-[#191919] font-bold text-base md:text-lg lg:text-xl">
              Terms of Service
            </h1>
          </div>

          {/* CONTENT */}
          <div className="w-11/12 sm:w-10/12 md:w-5/6 lg:w-4/5 xl:w-3/4 space-y-10">
            {/* 1 */}
            <section>
              <h2 className="text-lg md:text-xl font-bold text-black mb-4">
                1. Agreement to Terms
              </h2>

              <div className="space-y-6">
                <p className="text-[#191919] text-sm sm:text-base md:text-lg leading-6 sm:leading-7 md:leading-8 tracking-wide">
                  These Terms of Service (“Terms”) constitute a legally binding
                  agreement between you (“Service Provider”, “you”, or “your”)
                  and TiffinTap (“Company”, “we”, “us”, or “our”). By
                  registering an account and using the TiffinTap mobile
                  application (the “App”), you acknowledge that you have read,
                  understood, and agreed to these Terms.
                </p>

                <p className="text-[#191919] text-sm sm:text-base md:text-lg leading-6 sm:leading-7 md:leading-8 tracking-wide">
                  If you do not agree with these Terms, you must discontinue
                  using the App immediately.
                </p>
              </div>
            </section>

            {/* 2 */}
            <section>
              <h2 className="text-lg md:text-xl font-bold text-black mb-4">
                2. Scope of Services
              </h2>
              <p className="text-[#191919] text-sm sm:text-base md:text-lg leading-6 sm:leading-7 md:leading-8 tracking-wide">
                TiffinTap provides a digital platform that enables service
                providers to:
              </p>
              <ul className="list-disc pl-5 space-y-2 text-sm sm:text-base md:text-lg text-[#191919]">
                <li>Register and maintain their tiffin service details,</li>
                <li>Manage customer information and orders,</li>
                <li>Record deliveries and payment transactions,</li>
                <li>
                  Communicate with customers through integrated channels (e.g.,
                  call, WhatsApp, email),
                </li>
                <li>
                  Receive platform notifications (e.g., order summaries,
                  reminders).
                </li>
              </ul>
              <h2 className="text-lg md:text-xl font-bold text-black mb-4">
                TiffinTap does not:
              </h2>
              <p className="text-[#191919] text-sm sm:text-base md:text-lg leading-6 sm:leading-7 md:leading-8 tracking-wide">
                TiffinTap provides a digital platform that enables service
                providers to:
              </p>
              <ul className="list-disc pl-5 space-y-2 text-sm sm:text-base md:text-lg text-[#191919]">
                <li>Prepare, supply, or deliver food,</li>
                <li>Collect payments from your customers, or</li>
                <li>
                  Guarantee customer compliance with payments, orders, or
                  refunds.
                </li>
                <li>
                  All transactions for food services are strictly between you
                  and your customers.
                </li>
              </ul>
            </section>

            {/* 3 */}
            <section>
              <h2 className="text-lg md:text-xl font-bold text-black mb-4">
                3. Account Registration
              </h2>

              <ul className="list-disc pl-5 space-y-2 text-sm sm:text-base md:text-lg text-[#191919]">
                <li>
                  You must register with a valid email, phone number, and OTP
                  verification.
                </li>
                <li>
                  You are responsible for maintaining the confidentiality of
                  your credentials.
                </li>
                <li>
                  False, misleading, or incomplete registration details may
                  result in account suspension.
                </li>
              </ul>
            </section>

            {/* 4 */}
            <section>
              <h2 className="text-lg md:text-xl font-bold text-black mb-4">
                4. Subscription Plans, Billing & Payments
              </h2>
              <div className="space-y-6">
                <ul className="list-disc pl-5 space-y-3 text-sm sm:text-base md:text-lg text-[#191919]">
                  <li className="list-none font-semibold">
                    4.1 Payment Methods
                  </li>
                  <li>
                    Subscription fees must be paid in advance using approved
                    methods such as credit card, debit card, PayPal, or Stripe.
                  </li>
                  <li>
                    By submitting your payment details, you authorize TiffinTap
                    (or its third-party payment processor) to automatically
                    charge applicable subscription fees.
                  </li>
                  <li>
                    You are responsible for ensuring that your chosen payment
                    method remains valid and has sufficient funds.
                  </li>
                </ul>

                <ul className="list-disc pl-5 space-y-2 text-sm sm:text-base md:text-lg text-[#191919]">
                  <li className="list-none font-semibold">4.2 Currency</li>
                  <li>
                    Subscription fees are displayed in United States Dollars
                    (USD) by default.
                  </li>
                  <li>
                    Where available, fees may be converted and billed in your
                    local currency (e.g., CAD, GBP, EUR, INR, AUD).
                  </li>
                  <li>
                    {" "}
                    Exchange rates and conversion fees are determined by your
                    bank or payment provider and are outside TiffinTap’s
                    control.
                  </li>
                </ul>

                <ul className="list-disc pl-5 space-y-2 text-sm sm:text-base md:text-lg text-[#191919]">
                  <li className="list-none font-semibold">
                    4.3 Billing Cycle & Renewals
                  </li>
                  <li>
                    Renewal occurs automatically on the same calendar day each
                    month (e.g., if you subscribed on the 10th, your billing
                    date will be the 10th of each subsequent month).
                  </li>
                  <li>
                    If your billing date does not exist in a given month (e.g.,
                    February), renewal will occur on the last day of that month.
                  </li>
                  <li>
                    You authorize TiffinTap to automatically renew your
                    subscription unless you cancel prior to your next billing
                    date.
                  </li>
                </ul>
                <ul className="list-disc pl-5 space-y-2 text-sm sm:text-base md:text-lg text-[#191919]">
                  <li className="list-none font-semibold">
                    4.4 Rolling Monthly Subscriptions (30-Day Cycle)
                  </li>
                  <li>
                    When you subscribe, your billing cycle begins on the date of
                    activation and continues for 30 consecutive days.
                  </li>
                  <li>
                    Your next billing due date will be exactly 30 days after
                    activation (e.g., if you subscribe on March 13, your next
                    payment will be due on April 12).
                  </li>
                  <li>
                    Renewals will continue every 30 days thereafter, unless
                    cancelled.
                  </li>
                  <li>
                    The app will display your active plan status and upcoming
                    due date on your dashboard.
                  </li>
                  <li>
                    If you upgrade or downgrade your plan mid-cycle, the change
                    will apply immediately, and your billing cycle will reset to
                    the new activation date.
                  </li>
                </ul>
                <ul className="list-disc pl-5 space-y-2 text-sm sm:text-base md:text-lg text-[#191919]">
                  <li className="list-none font-semibold">
                    4.5 Failed Payments
                  </li>
                  <li>
                    If your payment method is declined, you will receive a
                    notification and a grace period of [7 days] to update your
                    billing details.
                  </li>
                  <li>
                    Failure to update within the grace period may result in
                    account suspension until payment is made.
                  </li>
                </ul>
                <ul className="list-disc pl-5 space-y-2 text-sm sm:text-base md:text-lg text-[#191919]">
                  <li className="list-none font-semibold">
                    4.6 Non-Refundable Fees
                  </li>
                  <li>
                    All subscription fees are prepaid and non-refundable, except
                    as required by applicable law.
                  </li>
                  <li>
                    Cancelling your subscription will stop further charges, but
                    you will not receive a refund for the current billing
                    period.
                  </li>
                </ul>
              </div>
            </section>

            {/* 5 */}
            <section>
              <h2 className="text-lg md:text-xl font-bold text-black mb-4">
                5. Customer Orders & Non-Payment Risks
              </h2>
              <ul className="list-disc pl-5 space-y-2 text-sm sm:text-base md:text-lg text-[#191919]">
                <li>
                  You are solely responsible for setting your prices and
                  recording customer orders.
                </li>
                <li>
                  TiffinTap provides order logs and payment tracking tools only.
                </li>
                <li>
                  If a customer fails to pay, it is your responsibility to
                  resolve the matter directly with the customer.
                </li>
                <li>
                  TiffinTap has no liability for customer non-payment, disputes,
                  or defaults.
                </li>
              </ul>
            </section>

            {/* 6 */}
            <section>
              <h2 className="text-lg md:text-xl font-bold text-black mb-4">
                6. Refunds & Cancellations (Service Provider to TiffinTap)
              </h2>

              <ul className="list-disc pl-5 space-y-2 text-sm sm:text-base md:text-lg text-[#191919]">
                <li>
                  Subscription cancellations take effect at the end of your
                  current billing cycle.
                </li>
                <li>
                  No partial or prorated refunds are provided for unused time.
                </li>
                <li>
                  Free trial accounts automatically convert to paid plans if not
                  cancelled before the trial period ends.
                </li>
              </ul>
            </section>

            {/* 7 */}
            <section>
              <h2 className="text-lg md:text-xl font-bold text-black mb-4">
                7. Notifications & Communications
              </h2>

              <ul className="list-disc pl-5 space-y-2 text-sm sm:text-base md:text-lg text-[#191919]">
                <li>
                  TiffinTap may send you order summaries, daily updates, or
                  important service notifications via email, WhatsApp, or in-app
                  alerts.
                </li>
                <li>
                  You consent to receive such communications as part of using
                  the App.
                </li>
                <li>
                  You remain responsible for reviewing your dashboard daily to
                  avoid missed orders.
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg md:text-xl font-bold text-black mb-4">
                8. Disputes with Customers
              </h2>

              <ul className="list-disc pl-5 space-y-2 text-sm sm:text-base md:text-lg text-[#191919]">
                <li>
                  All disputes regarding food quality, delivery, pricing, or
                  refunds must be resolved directly between you and your
                  customers.
                </li>
                <li>
                  TiffinTap is not a party to such disputes and bears no
                  liability.
                </li>
                <li>
                  You may use order and payment history logs from the App to
                  assist in resolving disputes.
                </li>
              </ul>
            </section>
            <section>
              <h2 className="text-lg md:text-xl font-bold text-black mb-4">
                9. Use of Data
              </h2>

              <ul className="list-disc pl-5 space-y-2 text-sm sm:text-base md:text-lg text-[#191919]">
                <li>
                  You grant TiffinTap the right to process and store data you
                  provide (e.g., menus, prices, customer details) for platform
                  functionality.
                </li>
                <li>
                  Customer data entered by you is considered your
                  responsibility. You must comply with applicable data privacy
                  laws when handling customer information.
                </li>
              </ul>
            </section>
            {/* section 10 */}
            <section>
              <h2 className="text-lg md:text-xl font-bold text-black mb-4">
                10. Prohibited Conduct
              </h2>
              <p className="text-[#191919] text-sm sm:text-base md:text-lg leading-6 sm:leading-7 md:leading-8 tracking-wide">
                You may not use the App to:
              </p>
              <ul className="list-disc pl-5 space-y-2 text-sm sm:text-base md:text-lg text-[#191919]">
                <li>Misrepresent services,</li>
                <li>Engage in fraudulent activity,</li>
                <li>Spam customers with irrelevant communication,</li>
                <li>Circumvent payment obligations to TiffinTap.</li>
              </ul>
            </section>
            <section>
              {/* section 11 */}
              <h2 className="text-lg md:text-xl font-bold text-black mb-4">
                10. Prohibited Conduct
              </h2>
              <p className="text-[#191919] text-sm sm:text-base md:text-lg leading-6 sm:leading-7 md:leading-8 tracking-wide">
                You may not use the App to:
              </p>
              <ul className="list-disc pl-5 space-y-2 text-sm sm:text-base md:text-lg text-[#191919]">
                <li>Misrepresent services,</li>
                <li>Engage in fraudulent activity,</li>
                <li>Spam customers with irrelevant communication,</li>
                <li>Circumvent payment obligations to TiffinTap.</li>
              </ul>
            </section>
            {/* section 12 */}
            <section>
              <h2 className="text-lg md:text-xl font-bold text-black mb-4">
                12. Indemnification
              </h2>
              <p className="text-[#191919] text-sm sm:text-base md:text-lg leading-6 sm:leading-7 md:leading-8 tracking-wide">
                You agree to indemnify, defend, and hold harmless TiffinTap from
                any claims, damages, losses, or expenses (including legal fees)
                arising from:
              </p>
              <ul className="list-disc pl-5 space-y-2 text-sm sm:text-base md:text-lg text-[#191919]">
                <li>Your provision of food services,</li>
                <li>Disputes with customers,</li>
                <li> Your breach of these Terms.</li>
              </ul>
            </section>
            {/* section 13 */}
            <section>
              <h2 className="text-lg md:text-xl font-bold text-black mb-4">
                13. Governing Law & Jurisdiction
              </h2>
              <p className="text-[#191919] text-sm sm:text-base md:text-lg leading-6 sm:leading-7 md:leading-8 tracking-wide">
                These Terms shall be governed by and construed in accordance
                with the laws of Gujarat, India. Disputes shall be subject to
                the exclusive jurisdiction of the courts of that jurisdiction.
              </p>
            </section>
            {/* section 14 */}
            <section>
              <h2 className="text-lg md:text-xl font-bold text-black mb-4">
                14. Termination
              </h2>
              <ul className="list-disc pl-5 space-y-2 text-sm sm:text-base md:text-lg text-[#191919]">
                <li>
                  TiffinTap may suspend or terminate your account for breach of
                  these Terms, non-payment, or misuse of the App.
                </li>
                <li>
                  You may terminate your account by cancelling your subscription
                  and discontinuing use.
                </li>
              </ul>
            </section>
            {/* section 15 */}
            <section>
              <h2 className="text-lg md:text-xl font-bold text-black mb-4">
                15. Changes to Terms
              </h2>
              <p className="text-[#191919] text-sm sm:text-base md:text-lg leading-6 sm:leading-7 md:leading-8 tracking-wide">
                TiffinTap may update these Terms at any time. Continued use of
                the App constitutes acceptance of revised Terms.
              </p>
            </section>

            {/* Section 16 */}
            <section>
              <h3 className="font-bold text-md md:text-lg mb-2">
                16. Contact Us
              </h3>
              <ul className="list-disc pl-5 text-sm sm:text-base md:text-lg text-[#191919] space-y-3">
                <li>
                  For support or questions regarding these Terms, please
                  contact:
                </li>

                <li className="flex items-center gap-2 list-none">
                  <img
                    src={mailIcon}
                    alt="email_icon"
                    className="w-4 h-4 md:w-5 md:h-5"
                  />
                  <a
                    href="mailto:hello@webapprise.com"
                    className="text-[#FF6943] underline hover:text-[#ff4d1c] transition-colors"
                  >
                    hello@webapprise.com
                  </a>
                </li>
              </ul>
            </section>
          </div>
        </div>
      </section>
    </>
  );
};

export default Terms;
